/**
 * Après Enzyme Coverage
 * Expandable card toggle via event delegation
 */
(function () {
  'use strict';

  var expList = document.querySelector('.exp-list');
  if (!expList) return;

  function toggleCard(main) {
    var card = main.parentElement;
    var isOpen = card.classList.toggle('open');
    main.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  expList.addEventListener('click', function (e) {
    var main = e.target.closest('.exp-main');
    if (!main) return;
    toggleCard(main);
  });

  expList.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var main = e.target.closest('.exp-main');
    if (!main) return;
    e.preventDefault();
    toggleCard(main);
  });
})();
